import type { ReactElement } from 'react';

export default function UnlockWithPlusChip(): ReactElement {
  return (
    <span className="vtwo:inline-flex vtwo:items-center vtwo:rounded-full vtwo:bg-linear-to-r vtwo:from-[#EADDF9] vtwo:to-[#DCEBFB] vtwo:px-3 vtwo:py-1 vtwo:text-xs vtwo:font-semibold vtwo:text-featured vtwo:whitespace-nowrap">
      Unlock with Plus+
    </span>
  );
}
